namespace $.$$ {

	$mol_style_define( $shm_ba_date, {
		alignItems: 'center',
		flex: {
			wrap: 'nowrap',
		},

		Date_from: {
			Bubble: {
				maxWidth: 'none',
			},
		},

		Date_to: {
			Bubble: {
				maxWidth: 'none',
			},
		},

		Date_from_bubble: {
			display: 'flex',
			flex: {
				direction: 'row',
				wrap: 'nowrap',
			},
			gap: '8px',
			alignItems: 'start',
			// background: {
			// 	color: $mol_theme.back,
			// },
		},

		Date_to_bubble: {
			display: 'flex',
			flex: {
				direction: 'row',
				wrap: 'nowrap',
			},
			gap: '8px',
			alignItems: 'start',
			// background: {
			// 	color: $mol_theme.back,
			// },
		},

		Presets_list: {
			flex: {
				basis: '150px',
				shrink: 0,
			},
			gap: '2px',
		},

		Date_from_calendar_column: {
			flex: {
				direction: 'column',
				basis: '240px',
				grow: 1,
			},
		},

		Date_to_calendar_column: {
			flex: {
				direction: 'column',
				basis: '240px',
				grow: 1,
			},
		},

		Preset: {
			justifyContent: 'flex-start',
		},
	} )

}
